import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { authApi } from '../api/client';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser]     = useState(null);
  const [school, setSchool] = useState(null);
  const [loading, setLoading] = useState(true);

  // Rehydrate from localStorage on mount + listen for storage changes
  useEffect(() => {
    const rehydrate = () => {
      try {
        const u = localStorage.getItem('user');
        const s = localStorage.getItem('school');
        if (u) setUser(JSON.parse(u));
        if (s) setSchool(JSON.parse(s));
      } catch { /* ignore */ }
    };
    rehydrate();
    setLoading(false);
    window.addEventListener('storage', rehydrate);
    return () => window.removeEventListener('storage', rehydrate);
  }, []);

  const login = useCallback((userData, schoolData, accessToken, refreshToken) => {
    localStorage.setItem('access_token',  accessToken);
    localStorage.setItem('refresh_token', refreshToken);
    localStorage.setItem('user',   JSON.stringify(userData));
    if (schoolData) localStorage.setItem('school', JSON.stringify(schoolData));
    setUser(userData);
    setSchool(schoolData || null);
  }, []);

  const logout = useCallback(async () => {
    try {
      const refresh = localStorage.getItem('refresh_token');
      await authApi.logout(refresh);
    } catch { /* ignore */ }
    localStorage.clear();
    setUser(null);
    setSchool(null);
  }, []);

  const value = { user, school, loading, login, logout, isLoggedIn: !!user };
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used inside AuthProvider');
  return ctx;
}
